import { ApiCacheTags, baseApiService } from '@qapline/api';
import { config } from 'config';
import { TGetUsersListResponseBody } from 'types';

export const userApi = baseApiService.injectEndpoints({
    endpoints: (builder) => ({
        getUsersList: builder.query<TGetUsersListResponseBody, void>({
            query: () => ({
                url: config.api.endpoints.user.list,
                method: 'GET',
            }),
            providesTags: [{ type: ApiCacheTags.user.list }],
        }),
    }),
});

export const { useGetUsersListQuery, useLazyGetUsersListQuery } = userApi;
